/**
 * Log/Report 필터
 *
 * @since 2018-11-30
 * @author 강정규 ( devp012 )
 */

export default {
  data () {
    return {
      maxSelectedCount: 30
    }
  },
  methods: {
    filterValidate (val, arrVal) {
      // 빈값인 경우 추가 불가
      if (val === '') {
        return false
      }

      // 중복 검사
      const findIdx = _.findIndex(arrVal, (str) => { return val === str })
      if (findIdx >= 0) {
        // this.$alertPopUp.show(this.$t('이미 추가되어 있습니다.')) // 중복 alert 창은 띄우지 않기로 협의 됨. 2018.11.29
        return false
      }

      // 최대 갯수 초과 검사
      if (arrVal.length >= this.maxSelectedCount) {
        this.$alertPopUp.show(window.$nuxt.$t('lr.log_filter_maxCount', { count: this.maxSelectedCount }))
        return false
      }

      // 추가된 문자열 길이 + 추가할 문자열 길이는 1000자까지 가능
      const currentCharLength = _.size(_.join(arrVal, ''))
      const newCharLength = _.size(val)
      if ((currentCharLength + newCharLength) > 1000) {
        this.$alertPopUp.show(window.$nuxt.$t('lr.log_filter_maxLength'))
        return false
      }
      return true
    },

    filterValidateMaxCount (arrVal) {
      // 최대 갯수 초과 검사
      if (arrVal.length > this.maxSelectedCount) {
        this.$alertPopUp.show(window.$nuxt.$t('lr.log_filter_maxCount', { count: this.maxSelectedCount }))
        return false
      }
      return true
    }
  }
}
